import * as React from 'react';
import { ItemList, ItemListProps } from '../common/ItemList';
import SettingPopup from '../common/SettingPopup';

export interface MultiroleLinkItem {
  readonly id: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly reference: string;
  readonly title: string;
}

export interface MultiroleLinkItemListPopupProps extends ItemListProps<MultiroleLinkItem> {
  title: string;
  isOpen: boolean;
  onClose: () => void;
}

export class MultiroleLinkItemListPopup extends React.PureComponent<
  MultiroleLinkItemListPopupProps, {}
> {

  public render() {
    if (!this.props.isOpen) {
      return null;
    }

    return (
      <SettingPopup title={this.props.title} onClose={this.props.onClose}>
        <ItemList
          items={this.props.items}
          onClick={this.props.onClick}
          onClickDelete={this.props.onClickDelete}
          createListRowItem={(item: MultiroleLinkItem) => (
            <span style={{ flex: 1 }}>
              {item.title}&nbsp;<span style={{ fontSize: '0.75em' }}>({item.reference})</span>
            </span>
          )}/>
      </SettingPopup>
    );
  }
}
